import { Link } from 'react-router-dom';

function FooterBar() {
  return (
    <footer className="helpdesk-footer">
      <div className="helpdesk-footer__inner">
        <p>&copy; 2024 DigiOne Technology Solutions. All rights reserved.</p>
        <nav aria-label="Legal links">
          <Link to="/articles/privacy-policy-2">Privacy Policy</Link>
          <Link to="/articles/terms-of-service-2">Terms of Service</Link>
          <Link to="/articles/service-level-agreement-2">Service Level Agreement</Link>
        </nav>
      </div>
    </footer>
  );
}

export default FooterBar;
